const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function sendErrorToBackend(payload) {
  try {
    // Use sendBeacon when available (works even during page unload)
    const data = JSON.stringify({ timestamp: Date.now(), userAgent: navigator.userAgent, ...payload });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API_URL}/log-error`, new Blob([data], { type: 'application/json' }));
    } else {
      fetch(`${API_URL}/log-error`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: data,
        keepalive: true,
      }).catch(() => {}); // silently ignore network errors in the logger itself
    }
  } catch (_) {
    // never throw from error logger
  }
}

export function logError(message, { stack, url, type = 'error', extra } = {}) {
  sendErrorToBackend({ type, message: String(message), stack, url: url || window.location.href, extra });
}

export function initGlobalErrorLogging() {
  // Catch uncaught JS errors (including minify crashes)
  window.onerror = (message, source, lineno, colno, error) => {
    logError(message, {
      type: 'window.onerror',
      stack: error?.stack,
      url: source,
      extra: { lineno, colno },
    });
    return false; // don't suppress default browser behaviour
  };

  // Catch unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    logError(reason?.message || String(reason), {
      type: 'unhandledrejection',
      stack: reason?.stack,
    });
  });

  // Intercept console.error so every console.error also reaches the backend
  const originalConsoleError = console.error.bind(console);
  console.error = (...args) => {
    originalConsoleError(...args);
    try {
      const message = args.map(a => (typeof a === 'object' ? JSON.stringify(a) : String(a))).join(' ');
      const stack = args.find(a => a instanceof Error)?.stack;
      logError(message, { type: 'console.error', stack });
    } catch (_) {}
  };
}
